import { render, staticRenderFns } from "./ObiPaidSale.vue?vue&type=template&id=3a94d979&scoped=true&"
import script from "./ObiPaidSale.vue?vue&type=script&lang=js&"
export * from "./ObiPaidSale.vue?vue&type=script&lang=js&"
import style0 from "./ObiPaidSale.vue?vue&type=style&index=0&id=3a94d979&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a94d979",
  null
  
)

export default component.exports